export type ManualSeatPickerAction =
 | { type: 'SET_IS_FETCHING_SECTIONS' }

 | { type: 'SET_IS_FETCHING_INNER_SECTION' }
 | { type: 'SET_IS_FETCHING_CURRENT_RESERVATIONS' }
 | { type: 'SET_FETCH_SECTIONS_FAILED' }
 | { type: 'SET_FETCH_INNER_SECTION_FAILED' }
 | { type: 'SET_FETCH_CURRENT_RESERVATIONS_FAILED' }
 | { type: 'INCREASE_RESERVATIONS_ON_FETCH', toAdd: number }
 | { type: 'DECREASE_RESERVATIONS_ON_FETCH', toRemove: number }
 | { type: 'SET_SECTION_OVERVIEW', sectionOverview: Julius.Website.SectionsOverviewModel }
 | { type: 'SET_INNER_SECTION', innerSection: Julius.Website.InnerSectionViewModel }
 | { type: 'SET_CURRENT_RESERVATION_RESULT', result: Julius.Website.ManualReservationViewModel }
 | { type: 'SET_RESERVATION_FAILED' }
 | { type: 'ADD_SELECTED_SEAT', seat: Julius.Website.OrderSeatViewModel }
 | { type: 'REMOVE_SELECTED_SEAT', seat: Julius.Website.OrderSeatViewModel }
 | { type: 'SET_SELECTED_SEATS', seats: Julius.Website.OrderSeatViewModel[] }
 | { type: 'APPEND_HOVERED_SEAT', seats: Julius.Website.SectionSeatViewModel[] }
 | { type: 'CLEAR_HOVERED_SEATS' }
 | { type: 'CLEAR_CONTENT' }
 | { type: 'SET_IS_FETCHING_RESERVATIONS', value: boolean }

 export const setIsFetchingSections = (): ManualSeatPickerAction => ({
  type: 'SET_IS_FETCHING_SECTIONS',
});

export const setIsFetchingInnerSection = (): ManualSeatPickerAction => ({
  type: 'SET_IS_FETCHING_INNER_SECTION',
});

export const setIsFetchingCurrentReservations = (): ManualSeatPickerAction => ({
  type: 'SET_IS_FETCHING_CURRENT_RESERVATIONS',
});

export const setFetchCurrentReservationsFailed = (): ManualSeatPickerAction => ({
  type: 'SET_FETCH_CURRENT_RESERVATIONS_FAILED',
});

export const setFetchSectionsFailed = (): ManualSeatPickerAction => ({
  type: 'SET_FETCH_SECTIONS_FAILED',
});

export const setFetchInnerSectionFailed = (): ManualSeatPickerAction => ({
  type: 'SET_FETCH_INNER_SECTION_FAILED',
});

export const increaseReservationsOnFetch = (toAdd: number): ManualSeatPickerAction => ({
  toAdd,
  type: 'INCREASE_RESERVATIONS_ON_FETCH',
});

export const decreaseReservationOnFetch = (toRemove: number): ManualSeatPickerAction => ({
  toRemove,
  type: 'DECREASE_RESERVATIONS_ON_FETCH',
});

export const setSectionOverview = 
  (sectionOverview: Julius.Website.SectionsOverviewModel): ManualSeatPickerAction => ({
    sectionOverview,
    type: 'SET_SECTION_OVERVIEW',
});

export const setInnerSection = 
  (innerSection: Julius.Website.InnerSectionViewModel): ManualSeatPickerAction => ({
    innerSection,
    type: 'SET_INNER_SECTION',
});

export const setCurrentReservations =
  (result: Julius.Website.ManualReservationViewModel): ManualSeatPickerAction => ({
    result,
    type: 'SET_CURRENT_RESERVATION_RESULT',
});

export const setNewReservationFailed = (): ManualSeatPickerAction => ({
    type: 'SET_RESERVATION_FAILED',
});

export const addSelectedSeat = (seat: Julius.Website.OrderSeatViewModel): ManualSeatPickerAction => ({
  seat,
  type: 'ADD_SELECTED_SEAT',
});

export const removeSelectedSeat = (seat: Julius.Website.OrderSeatViewModel): ManualSeatPickerAction => ({
  seat,
  type: 'REMOVE_SELECTED_SEAT',
});

export const setSelectedSeats = (seats: Julius.Website.OrderSeatViewModel[]): ManualSeatPickerAction => ({
  seats,
  type: 'SET_SELECTED_SEATS',
});

export const clearContent = () => ({
  type: 'CLEAR_CONTENT', 
});

export const appendHoveredSeat = (seats: Julius.Website.SectionSeatViewModel[]) => ({
  type: 'APPEND_HOVERED_SEAT',
  seats,
});

export const clearHoveredSeats = () => ({
  type: 'CLEAR_HOVERED_SEATS',
});

export const setIsFetchingReservations = (value: boolean): ManualSeatPickerAction => ({
  type: 'SET_IS_FETCHING_RESERVATIONS',
  value,
});


// WEBPACK FOOTER //
// ./src/components/PickSeatManually/Redux/actions.tsx